// extracted by mini-css-extract-plugin
export default {"bulletCount":"BulletCount_bulletCount__nrA41","icon":"BulletCount_icon__B9C2J","indicator":"BulletCount_indicator__dxRns","weaponImg":"BulletCount_weaponImg__g6ozp"};